import React from 'react';
import eclipse from '../../assets/images/eclipse.png';
import eclipseselected from '../../assets/images/eclipseselected.png';
import DonneesComp from './DonneesComp/DonneesComp';
import carte from "../../assets/images/carte.jpg"
const DonneesSolList = ({ myData, selectedSection, setSelectedSection }) => {
  return (
    <div className="pt-24 pb-12 grid">
      <div className="grid grid-cols-2">
        <div
          className="flex items-center justify-center space-x-4 cursor-pointer"
          onClick={() => { setSelectedSection("donnees") }}
        >
          {selectedSection === "donnees" ? 
            <img className="h-5 w-5" src={eclipseselected} alt="someimg" /> : 
            <img className="h-5 w-5" src={eclipse} alt="someimg" />}
          <span className={`text-[#006DC4] hover:text-[#FFDF00] transition-all`}>Donnees</span>
        </div>
        <div
          className="flex items-center justify-center space-x-4 cursor-pointer"
          onClick={() => { setSelectedSection("solution") }}
        >
          {selectedSection === "solution" ? 
            <img className="h-5 w-5" src={eclipseselected} alt="someimg" /> : 
            <img className="h-5 w-5" src={eclipse} alt="someimg" />}
          <span className={`text-[#006DC4] hover:text-[#FFDF00] transition-all`}>Solutions</span>
        </div>
      </div>

      <div className="mt-8 grid justify-items-center   px-4">
        {/* Chart Placeholder with Title */}
        <div className="chart-container mb-8  grid justify-items-center">
          <h2 className="text-[#006DC4] font-bold text-2xl">Carete Graphic</h2>
          <div className="chart-placeholder ">
            <img src={carte}   alt="Carete Graphic" className="w-full object-contain" />
          </div>
        </div>

        {/* Table displaying the collected results */}
        <div className="table-container grid justify-items-center">
          <h3 className="text-[#006DC4] text-2xl font-bold mb-4">Tableau 1: Paramètres physiques et chimiques de l'eau</h3>
          <table className="w-3/4 table-auto border-collapse">
  <thead>
    <tr>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Variable</th>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Unité</th>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Min</th>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Max</th>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Moyenne</th>
      <th className="bg-[#FFDF00] text-[#006DC4] py-2 px-4 border border-[#006DC4]">Irrigation guideline FAO (2011)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">T</td>
      <td className="py-2 px-4 border border-[#006DC4]">°C</td>
      <td className="py-2 px-4 border border-[#006DC4]">26</td>
      <td className="py-2 px-4 border border-[#006DC4]">29.5</td>
      <td className="py-2 px-4 border border-[#006DC4]">28.62</td>
      <td className="py-2 px-4 border border-[#006DC4]"></td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">pH</td>
      <td className="py-2 px-4 border border-[#006DC4]">/</td>
      <td className="py-2 px-4 border border-[#006DC4]">8.27</td>
      <td className="py-2 px-4 border border-[#006DC4]">8.73</td>
      <td className="py-2 px-4 border border-[#006DC4]">8.48</td>
      <td className="py-2 px-4 border border-[#006DC4]">8.5</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">C.E</td>
      <td className="py-2 px-4 border border-[#006DC4]">ms/cm</td>
      <td className="py-2 px-4 border border-[#006DC4]">2.82</td>
      <td className="py-2 px-4 border border-[#006DC4]">28</td>
      <td className="py-2 px-4 border border-[#006DC4]">10.78</td>
      <td className="py-2 px-4 border border-[#006DC4]">3</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">TDS</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">1804.8</td>
      <td className="py-2 px-4 border border-[#006DC4]">17920</td>
      <td className="py-2 px-4 border border-[#006DC4]">9862.4</td>
      <td className="py-2 px-4 border border-[#006DC4]">2000</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">Cl-</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">607.2</td>
      <td className="py-2 px-4 border border-[#006DC4]">8703.9</td>
      <td className="py-2 px-4 border border-[#006DC4]">3203.8</td>
      <td className="py-2 px-4 border border-[#006DC4]">1060</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">NO3-</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">Nd</td>
      <td className="py-2 px-4 border border-[#006DC4]">290.2</td>
      <td className="py-2 px-4 border border-[#006DC4]">290.2</td>
      <td className="py-2 px-4 border border-[#006DC4]">30</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">SO42-</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">114.65</td>
      <td className="py-2 px-4 border border-[#006DC4]">719.05</td>
      <td className="py-2 px-4 border border-[#006DC4]">319.7</td>
      <td className="py-2 px-4 border border-[#006DC4]">960</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">Na+</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">401.53</td>
      <td className="py-2 px-4 border border-[#006DC4]">3760.5</td>
      <td className="py-2 px-4 border border-[#006DC4]">1527.06</td>
      <td className="py-2 px-4 border border-[#006DC4]">920</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">K+</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">23.1</td>
      <td className="py-2 px-4 border border-[#006DC4]">167.9</td>
      <td className="py-2 px-4 border border-[#006DC4]">74.64</td>
      <td className="py-2 px-4 border border-[#006DC4]">2</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">Mg2+</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">40.3</td>
      <td className="py-2 px-4 border border-[#006DC4]">469.1</td>
      <td className="py-2 px-4 border border-[#006DC4]">185.4</td>
      <td className="py-2 px-4 border border-[#006DC4]">60</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">Ca2+</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">44.8</td>
      <td className="py-2 px-4 border border-[#006DC4]">212.15</td>
      <td className="py-2 px-4 border border-[#006DC4]">114.08</td>
      <td className="py-2 px-4 border border-[#006DC4]">400</td>
    </tr>
    <tr>
      <td className="py-2 px-4 border border-[#006DC4]">NH4+</td>
      <td className="py-2 px-4 border border-[#006DC4]">mg/l</td>
      <td className="py-2 px-4 border border-[#006DC4]">4.5</td>
      <td className="py-2 px-4 border border-[#006DC4]">23.1</td>
      <td className="py-2 px-4 border border-[#006DC4]">21.25</td>
      <td className="py-2 px-4 border border-[#006DC4]"></td>
    </tr>
  </tbody>
</table>

        </div>
      </div>
    </div>
  )
}

export default DonneesSolList;
